import { Profile } from '@news-mono/web-common'
import React from 'react'
import {
    StyledBylineFooter,
    StyledBylineHeading,
    StyledBylineSubHeading,
    StyledBylineWrapper,
    StyledTimestamp,
    StyledBylineHeadingLink,
} from './Byline.styled'
import { getProfileLink } from '../../helpers/getProfileLink'

interface BylineTextProps {
    profile: Profile[] | undefined
    source: string | undefined
    timestamp?: string | undefined
    text: string | undefined
    readTimeMinutes: number | null
    isContentPartner: boolean
}

export const BylineText: React.FC<BylineTextProps> = ({
    source,
    timestamp,
    profile,
    text,
    readTimeMinutes,
    isContentPartner,
}) => {
    const profileLink = profile && getProfileLink(profile)

    /**                   ↓----Byline Text----↓
     *  |~~~~~~~~~~~|~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~|~~~~~~~~~~~~~~~|
     *  | profile   |   Top Row // Name             |               |
     *  | pic       |~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~| Container     |
     *  |           |   Middle Row // Publisher     |               |
     *  |___________|~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~| Container     |
     *              |   Bottom Row // Min read/Date |               |
     *              |~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~|_______________|
     */

    return (
        <StyledBylineWrapper>
            {/* Use a clickable link if one exists for the profile */}
            {profileLink ? (
                <StyledBylineHeadingLink to={profileLink}>
                    {text}
                </StyledBylineHeadingLink>
            ) : (
                <StyledBylineHeading>{text}</StyledBylineHeading>
            )}
            {source && (
                <StyledBylineSubHeading>
                    {source}
                    {isContentPartner && (
                        <StyledBylineFooter>
                            &nbsp;/ CONTENT PARTNER
                        </StyledBylineFooter>
                    )}
                </StyledBylineSubHeading>
            )}
            <StyledBylineFooter>
                {readTimeMinutes && (
                    <span>{Math.ceil(readTimeMinutes)} Min Read</span>
                )}{' '}
                <StyledTimestamp
                    iconVisible={true}
                    timestamp={timestamp!}
                    timestampFormat={'dayMonthYear'} //Todo: tokenize?
                    timestampLabel={''}
                />
            </StyledBylineFooter>
        </StyledBylineWrapper>
    )
}
